import { createSlice } from '@reduxjs/toolkit';


const initialStateValue = {
    totalLampadaires: 0,
    totalFrontiere: 0,
    totalFrontiereSavanes: 0,
    totalFrontiereOuest: 0,
    totalFrontiereEst: 0,
    totalFrontiereSudEst: 0,
    totalVillageCiso: 0,
    totalVillageCisoSavanes: 0,
    totalVillageCisoAutresRegions: 0,
    totalZoneCiso: 0,
    totalZoneCisoSavanes: 0,
    totalZoneCisoAutresRegions: 0,
    totalInfraHorsCisoEducation: 0,
    totalInfraHorsCisoSante: 0,
    totalInfraHorsCisoEau: 0,
    resultStatus: false,
};

/* eslint-disable */
export const simulationResultSlice = createSlice({
    name: 'simulationResult',
    initialState: { value: initialStateValue },
    reducers: {
        updateSimulationResult: (state, action) => {
            state.value = action.payload;
        },
        toggleStatus: state => {
            state.resultStatus = !state.resultStatus
        }
    }
});
/* eslint-enable */

export const { updateSimulationResult, toggleStatus } = simulationResultSlice.actions;
export default simulationResultSlice.reducer;